module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"sidemenu":{"external":{"hub":"Hub","shop":"Shop","help_center":"Ajuda","simulator":"Simulador de vendas"}}},"en-US":{"sidemenu":{"external":{"hub":"Hub","shop":"Shop","help_center":"HELP","simulator":"Sales simulator"}}}}')
  delete Component.options._Ctor
}
